import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canActivateAuth } from './core/guards/auth.guard';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { NotFoundComponent } from './views/not-found/not-found.component';

const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('./features/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'app',
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import('./features/app-shell/app-shell.module').then(
                (m) => m.AppShellModule
            ),
    },
    {
        path: 'onboarding',
        component: AdminLayoutComponent,
        canActivate: [canActivateAuth],
        loadChildren: () =>
            import('./features/onboarding/onboarding.module').then(
                (m) => m.OnboardingModule
            ),
    },
    { path: '**', component: NotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { enableTracing: true })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
